import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-pagination" }

import {ref} from "vue";

  interface Props {
    total: number;
    currentPage: number;
    layout?: string
  }

  
import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: "HPagination",
  
})

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    total: { default: 0 },
    currentPage: { default: 1 },
    layout: { default: "total, prev, pager, next" }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

  const emit = __emit;
  

  /**
   * @description 页码改变触发事件
   * @param value
   */
  const currentChangeEvent = (value: number) => {
    emit("change", value);
  }


return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_pagination, {
      onCurrentChange: currentChangeEvent,
      "page-size": 15,
      "current-page": _ctx.currentPage,
      background: "",
      layout: _ctx.layout,
      total: _ctx.total
    }, null, 8, ["current-page", "layout", "total"])
  ]))
}
}

})